export default __webpack_public_path__ + "static/media/heineken.691d2609.svg";